module.exports = {"common":{"breadcrumb":{"home":"HOME","Directory":"Azure Active Directory","server":"Azure Active Directory Details","create_azure_ad_btn":"Add Azure App Credentials"}},"create_azure_ad":{"title":{"header":"Azure app credentials","desc":""},"btn":{"save":"Add","close":"Close","validate":"Validate"},"inputs":{"clientId":{"label":"Client Id","placeholder":"Enter Client Id"},"objectId":{"label":"Object Id","placeholder":"Enter Object Id"},"secretKey":{"label":"Secret Value","placeholder":"Enter Secret Value"},"status":{"label":"Status"}}},"update_azure_btn":{"update":"Update"}}


//////////////////
// WEBPACK FOOTER
// ./lang/en/ssoAzure.json
// module id = 1094
// module chunks = 32